'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.WasmEngine = /*#__PURE__*/function () {
  function WasmEngine() {
    (0, _classCallCheck2["default"])(this, WasmEngine);
    this._api = null;
    this._canvas = null;
    this._active = false;
  }
  return (0, _createClass2["default"])(WasmEngine, [{
    key: "isAvailable",
    value: function isAvailable() {
      return typeof window.EntryCompiler !== 'undefined' && typeof window.EntryCompiler.run === 'function';
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this._active;
    }
  }, {
    key: "_getProjectJSON",
    value: function _getProjectJSON() {
      return {
        objects: Entry.container.toJSON(),
        scenes: Entry.scene.toJSON(),
        variables: Entry.variableContainer.getVariableJSON(),
        messages: Entry.variableContainer.getMessageJSON(),
        functions: Entry.variableContainer.getFunctionJSON(),
        speed: Entry.FPS
      };
    }
  }, {
    key: "_createOverlayCanvas",
    value: function _createOverlayCanvas() {
      var entryCanvas = document.getElementById('entryCanvas');
      if (!entryCanvas) {
        return null;
      }
      var parent = entryCanvas.parentNode;
      if (window.getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      var canvas = document.createElement('canvas');
      canvas.id = 'wasmCanvas';
      canvas.width = 1920;
      canvas.height = 1080;
      canvas.style.position = 'absolute';
      canvas.style.top = entryCanvas.offsetTop + 'px';
      canvas.style.left = entryCanvas.offsetLeft + 'px';
      canvas.style.width = entryCanvas.offsetWidth + 'px';
      canvas.style.height = entryCanvas.offsetHeight + 'px';
      canvas.style.zIndex = '10';
      canvas.style.background = '#fff';
      parent.appendChild(canvas);
      entryCanvas.style.visibility = 'hidden';
      return canvas;
    }
  }, {
    key: "_pauseEntryJS",
    value: function _pauseEntryJS() {
      if (Entry.stage && Entry.stage.timer) {
        clearTimeout(Entry.stage.timer);
        Entry.stage.timer = null;
      }
      if (Entry.engine && Entry.engine.ticker) {
        clearInterval(Entry.engine.ticker);
        Entry.engine.ticker = null;
      }
      Entry.requestUpdate = false;
    }
  }, {
    key: "_resumeEntryJS",
    value: function _resumeEntryJS() {
      Entry.requestUpdate = true;
      if (Entry.stage && !Entry.stage.timer) {
        Entry.stage.render();
      }
    }
  }, {
    key: "_removeOverlayCanvas",
    value: function _removeOverlayCanvas() {
      if (this._canvas && this._canvas.parentNode) {
        this._canvas.parentNode.removeChild(this._canvas);
      }
      this._canvas = null;
      var entryCanvas = document.getElementById('entryCanvas');
      if (entryCanvas) {
        entryCanvas.style.visibility = '';
      }
    }
  }, {
    key: "start",
    value: function () {
      var _start = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var projectJSON, api, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.isAvailable() || this._active)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", false);
            case 1:
              projectJSON = this._getProjectJSON();
              this._canvas = this._createOverlayCanvas();
              if (this._canvas) {
                _context.next = 2;
                break;
              }
              console.error('[WasmEngine] Could not create overlay canvas');
              return _context.abrupt("return", false);
            case 2:
              this._active = true;
              this._pauseEntryJS();
              _context.prev = 3;
              console.log('[WasmEngine] Compiling project...');
              _context.next = 4;
              return window.EntryCompiler.run(this._canvas, projectJSON, {
                assetBaseUrl: Entry.baseUrl || 'https://playentry.org'
              });
            case 4:
              api = _context.sent;
              if (this._active) {
                _context.next = 5;
                break;
              }
              try {
                api.stop();
              } catch (e) {}
              return _context.abrupt("return", false);
            case 5:
              this._api = api;
              console.log('[WasmEngine] Project started');
              return _context.abrupt("return", true);
            case 6:
              _context.prev = 6;
              _t = _context["catch"](3);
              if (this._active) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", false);
            case 7:
              console.error('[WasmEngine] Failed to start:', _t);
              this._resumeEntryJS();
              this._active = false;
              this._removeOverlayCanvas();
              if (Entry.toast) {
                Entry.toast.alert('WASM 컴파일 오류', _t.message || 'WASM compilation failed', true);
              }
              return _context.abrupt("return", false);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 6]]);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (this._api) {
        try {
          this._api.stop();
        } catch (e) {
          console.warn('[WasmEngine] Stop error:', e);
        }
        this._api = null;
      }
      this._resumeEntryJS();
      this._removeOverlayCanvas();
      this._active = false;
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this._api) {
        try {
          this._api.pause();
        } catch (e) {
          console.warn('[WasmEngine] Pause error:', e);
        }
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (this._api) {
        try {
          this._api.resume();
        } catch (e) {
          console.warn('[WasmEngine] Resume error:', e);
        }
      }
    }
  }]);
}();